// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__1TgzI","root":"Modal_root__3Mk4M","inner":"Modal_inner__DUIkk","close":"Modal_close__2EfR5","actions":"Modal_actions__34qLX"};